import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, tap } from 'rxjs';
import { SEARCH_RESULTS_URL } from '@search/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  readonly searchNavigationEnabled = signal<boolean>(false);
  readonly #destroyRef = inject(DestroyRef);
  /**
   * Handler that sets the searchNavigationEnabled to false when we route to the search results page.
   */
  readonly _navigationEnabledHandler = inject(Router)
    .events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      filter((event) => event.url.startsWith(SEARCH_RESULTS_URL)),
      tap(() => this.searchNavigationEnabled.set(false)),
      takeUntilDestroyed(this.#destroyRef)
    )
    .subscribe();
}
